import React from 'react';
import { useNavigate } from 'react-router-dom';
import DigitalDisplay from '../components/DigitalDisplay';
import './Home.css';

const Home = () => {
  const navigate = useNavigate();
  const isMobile = window.innerWidth <= 768; // Adjust for mobile and tablet screens

  return (
    <div className="page-container">
      <DigitalDisplay>
        <div className="display-top">
          <h1 className="title-text">The $1 Odyssey</h1>
        </div>
      </DigitalDisplay>
      <div className="button-group">
        <button className="choice-button" onClick={() => navigate('/about')}>
          About{' '}
          <img
            src="/assets/images/solana_1_dollar_stable_memecoin_270x248px.png"
            alt="$1 Logo"
            className="logo"
          />
        </button>
        <button
          className="choice-button"
          onClick={() => navigate('/storyline')}
        >
          {isMobile ? (
            <>
              Enter{' '}
              <img
                src="/assets/images/solana_1_dollar_stable_memecoin_270x248px.png"
                alt="$1 Logo"
                className="logo"
              />{' '}
              Odyssey
            </>
          ) : (
            <>
              Enter Into The{' '}
              <img
                src="/assets/images/solana_1_dollar_stable_memecoin_270x248px.png"
                alt="$1 Logo"
                className="logo"
              />{' '}
              Odyssey
            </>
          )}
        </button>
      </div>
    </div>
  );
};

export default Home;
